import { t } from '@/shared/i18n/messages';
import { useAppToastStore } from '@/stores/app-toast-store';
import { useSiteProfileStore } from '@/stores/site-profile-store';

/**
 * 在线客服入口：链接由后台站点配置下发。
 * - preload：进入含客服入口的界面时预拉，保证点击时能同步 window.open（避免被移动端拦截弹窗）。
 * - open：有链接新开窗口；未配置/未拉到/被拦截时给明确提示，不静默失败。
 */
export function useSupportChat() {
  const siteProfile = useSiteProfileStore();
  const appToast = useAppToastStore();

  function preload() {
    void siteProfile.load();
  }

  function openUrl(url: string) {
    const win = window.open(url, '_blank', 'noopener,noreferrer');
    if (!win) {
      appToast.info(t('oro.auth.contactSupport'));
    }
  }

  async function ensureLoaded() {
    if (!siteProfile.loaded) {
      await siteProfile.load();
    }
  }

  async function open() {
    if (siteProfile.supportUrl) {
      openUrl(siteProfile.supportUrl);
      return;
    }
    await ensureLoaded();
    if (siteProfile.supportUrl) {
      openUrl(siteProfile.supportUrl);
      return;
    }
    appToast.info(t('oro.auth.contactSupport'));
  }

  async function openTelegram() {
    if (siteProfile.telegramUrl) {
      openUrl(siteProfile.telegramUrl);
      return;
    }
    await ensureLoaded();
    if (siteProfile.telegramUrl) {
      openUrl(siteProfile.telegramUrl);
      return;
    }
    appToast.info(t('oro.auth.contactSupport'));
  }

  return { open, openTelegram, preload, siteProfile };
}
